/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { TeamRole } from './TeamRole';
import { TeamRoleFromJSON, TeamRoleFromJSONTyped, TeamRoleToJSON, } from './TeamRole';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface UpdateTeamMembershipRequest
 *
 */
// create custom validators for the regexes
export interface UpdateTeamMembershipRequest {
    /**
     *
     * #type TeamRole
     * #memberof UpdateTeamMembershipRequest
        
        
         */
    role: TeamRole;
}
/**
 * Check if a given object implements the UpdateTeamMembershipRequest interface.
 */
export function instanceOfUpdateTeamMembershipRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { TeamRoleValidator, TeamRoleStringifyShape, TeamRoleStringifyShapeProperties, } from './TeamRole';
export const UpdateTeamMembershipRequestTypiaAssertEquals = (input: any) => {
    return ((input: any): UpdateTeamMembershipRequest => {
        const __is = (input: any, _exceptionable: boolean = true): input is UpdateTeamMembershipRequest => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => ("OWNER" === input.role || "ADMIN" === input.role || "MEMBER" === input.role || "SERVICEACCOUNT" === input.role) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["role"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateTeamMembershipRequest => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("OWNER" === input.role || "ADMIN" === input.role || "MEMBER" === input.role || "SERVICEACCOUNT" === input.role || $guard(_exceptionable, {
                    path: _path + ".role",
                    expected: "(\"ADMIN\" | \"MEMBER\" | \"OWNER\" | \"SERVICEACCOUNT\")",
                    value: input.role
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["role"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "UpdateTeamMembershipRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "UpdateTeamMembershipRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const UpdateTeamMembershipRequestTypiaAssertStringify = (input: UpdateTeamMembershipRequest): string => {
    return ((input: any): string => { const assert = (input: any): UpdateTeamMembershipRequest => {
        const __is = (input: any): input is UpdateTeamMembershipRequest => {
            const $io0 = (input: any): boolean => "OWNER" === input.role || "ADMIN" === input.role || "MEMBER" === input.role || "SERVICEACCOUNT" === input.role;
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateTeamMembershipRequest => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => "OWNER" === input.role || "ADMIN" === input.role || "MEMBER" === input.role || "SERVICEACCOUNT" === input.role || $guard(_exceptionable, {
                    path: _path + ".role",
                    expected: "(\"ADMIN\" | \"MEMBER\" | \"OWNER\" | \"SERVICEACCOUNT\")",
                    value: input.role
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "UpdateTeamMembershipRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "UpdateTeamMembershipRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: UpdateTeamMembershipRequest): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $so0 = (input: any): any => `{"role":${(() => {
            if ("string" === typeof input.role)
                return $string(input.role);
            if ("string" === typeof input.role)
                return "\"" + input.role + "\"";
            $throws({
                expected: "(\"ADMIN\" | \"MEMBER\" | \"OWNER\" | \"SERVICEACCOUNT\")",
                value: input.role
            });
        })()}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const UpdateTeamMembershipRequestValidatorShape = {
    'role': TeamRoleValidator.defined(),
};
export const UpdateTeamMembershipRequestValidator = yup.object().shape(UpdateTeamMembershipRequestValidatorShape);
export const UpdateTeamMembershipRequestStringifyShapeProperties: ObjectSchema['properties'] = {
    'role': TeamRoleStringifyShape,
};
export const UpdateTeamMembershipRequestStringifyShape: ObjectSchema = {
    title: 'UpdateTeamMembershipRequest Stringifier',
    type: 'object',
    properties: {
        ...UpdateTeamMembershipRequestStringifyShapeProperties
    },
    required: [
        'role',
    ],
};
export const UpdateTeamMembershipRequestStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(UpdateTeamMembershipRequestStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const UpdateTeamMembershipRequestStringify: (data: UpdateTeamMembershipRequest) => string = UpdateTeamMembershipRequestStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function UpdateTeamMembershipRequestFromJSON(json: any): UpdateTeamMembershipRequest {
    return UpdateTeamMembershipRequestFromJSONTyped(json, false);
}
export function UpdateTeamMembershipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTeamMembershipRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'role': TeamRoleFromJSON(json['role']),
    };
}
export function UpdateTeamMembershipRequestToJSON(value?: UpdateTeamMembershipRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'role': TeamRoleToJSON(value.role),
    };
}
